<template>
  <public-layout>
    <div class="signin__header">
      <h1 v-bg-typography="'h1'">Welcome to Brainpeek</h1>
      <p v-bg-typography="'m-body'">a Braingineers product</p>
    </div>
    <form v-on:submit.prevent="postSignin" class="signin">
      <h2 v-bg-typography="'h3'">New Password</h2>
      <ValidationProvider
        rules="required|min:6"
        vid="confirmation"
        v-slot="{ errors, valid, changed }"
      >
        <bg-field label="Password" :error="errors && errors[0]" name="password">
          <bg-input
            v-model="password"
            :error="errors && errors[0]"
            :valid="changed && valid"
            type="password"
          />
        </bg-field>
      </ValidationProvider>
      <ValidationProvider
        rules="required|password:confirmation"
        v-slot="{ errors, valid, changed }"
      >
        <bg-field
          :error="errors && errors[0]"
          label="Re-enter password"
          name="password"
        >
          <bg-input
            :error="errors && errors[0]"
            :valid="changed && valid"
            v-model="password2"
            type="password"
          />
        </bg-field>
      </ValidationProvider>
      <div class="action-container">
        <bg-button
          :isLoading="isLoading"
          class="signin-button"
          text="Change password"
          type="submit"
        />
      </div>
    </form>
  </public-layout>
</template>

<style scoped>
.signup-button {
  display: inline;
}
.names {
  display: flex;
  justify-content: space-between;
}

.first_name {
  margin-right: 10px;
}

.last_name {
  margin-left: 10px;
}

.action-container {
  display: flex;
  margin-top: 20px;
}
.forgot-password {
  flex-grow: 1;
  align-self: center;
  text-align: center;
}
.forms-container {
  display: flex;
  margin-bottom: 30px;
}
.signin {
  max-width: 600px;
  margin: auto;
}

.validation-sent {
  text-align: center;
  margin-top: 30px;
}

.signin__header {
  text-align: center;
  margin-bottom: 40px;
}

.disclaimer {
  max-width: 400px;
  text-align: center;
  margin: auto;
  font-size: 16px;
  color: var(--bg-color-text-light);
}

.disclaimer-text {
  color: var(--bg-color-text-link);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-active {
  transition-delay: 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
import PublicLayout from "@/layouts/public";
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgCheckbox from "@/components/bg-checkbox";
import API from "@/api";

export default {
  name: "signup",
  components: {
    BgButton,
    BgInput,
    BgField,
    BgCheckbox,
    PublicLayout,
  },
  directives: {
    BgTypography,
  },
  data: () => ({
    isLoading: false,
    password: "",
    password2: "",
    error: null,
  }),
  methods: {
    async postSignin() {
      if (this.password !== this.password2) {
        return null;
      }
      this.isLoading = true;
      const token = this.$route.query.token;
      const res = await API.user.newPassword(this.password, token);
      if (res.errors) {
        this.isLoading = false;
        this.error = res.errors[0];
      } else {
        this.$router.push({ path: `/signup` });
      }
    },
  },
};
</script>
